export enum CityFormFields {
    CITY = "city",
    STATE = "state",
    COUNTRY = "country",
}
